import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async requestProStatusActivation(chainId, pharmacyId) {
    try {
      const response = await axiosPrivate.post(`/chains/${chainId}/request-pro-activation`, {
        pharmacy_id: pharmacyId,
      });
      return response.data;
    } catch (error) {
      return helpers.throwError(error.response.data.error);
    }
  },

  async activateProStatus(chainId) {
    const response = await axiosPrivate.post(`/chains/${chainId}/activate-pro`);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async requestProDetails(chainId, pharmacyId) {
    try {
      const response = await axiosPrivate.post(`/chains/${chainId}/request-pro-details`, {
        pharmacy_id: pharmacyId,
      });
      return response.data;
    } catch (error) {
      return helpers.throwError(error.response.data.error);
    }
  },

  async registerWebsiteInterest(chainId, pharmacyId) {
    try {
      const response = await axiosPrivate.post(`/chains/${chainId}/register-website-interest`, {
        pharmacy_id: pharmacyId,
      });
      return response.data;
    } catch (error) {
      return helpers.throwError(error.response.data.error);
    }
  },
};
